import { Observable } from 'rxjs';
import _ from 'lodash';
import { startSubmit, stopSubmit, initialize } from 'redux-form/immutable';
import { push, replace } from 'react-router-redux';

import { selectFormById } from 'entities/form/selectors';
import FormsApi from 'entities/form/api';
import { showMessageAction, showErrorAction } from 'containers/Notification/actions';

import {
  initSuccessAction,
  initFailedAction,
  saveSuccessAction,
  saveFailedAction,
} from './actions';
import { FORM_IDENTIFIER, INIT, SAVE } from './constants';

const init = (action$, store) =>
  action$.ofType(INIT).mergeMap(({ id, isSurvey }) => {
    const actions = [];
    const state = store.getState();

    if (id === 'new') {
      actions.push(
        Observable.of(
          initialize(FORM_IDENTIFIER, {
            isSurvey,
          })
        )
      );
    } else {
      const form = selectFormById(state, id);
      if (form) {
        actions.push(Observable.of(initialize(FORM_IDENTIFIER, form)));
      } else {
        actions.push(
          FormsApi.fetch(id)
            .map((action) => [action, initialize(FORM_IDENTIFIER, action.form)])
            .catch((e) => Observable.of(initFailedAction(e), replace('/notFound')))
        );
      }
    }

    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) => [..._.flatten(resultingActions), initSuccessAction()])
      .catch((e) => Observable.of(initFailedAction(e)));
  });

const save = (action$) =>
  action$.ofType(SAVE).mergeMap((payload) =>
    Observable.concat(
      Observable.of(startSubmit(FORM_IDENTIFIER)),
      Observable.from(
        payload.data.id
          ? FormsApi.update(payload.data.id, payload.data)
          : FormsApi.create(payload.data)
      )
        .mergeMap((action) =>
          [
            action,
            saveSuccessAction(action),
            stopSubmit(FORM_IDENTIFIER),
            push(`${payload.data.isSurvey ? '/surveys' : '/forms'}/${action.form.get('id')}`),
            showMessageAction(
              payload.data.id
                ? 'Changes Saved!'
                : payload.data.isSurvey
                ? 'Survey Created!'
                : 'Form Created!'
            ),
          ].filter(Boolean)
        )
        .catch((e) =>
          Observable.of(
            saveFailedAction(e, 'saveFailed'),
            stopSubmit(FORM_IDENTIFIER),
            showErrorAction('An error occurred during saving, please try again.')
          )
        )
    )
  );

export default [init, save];
